'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import { FlexColumn } from 'src/components/Atoms/FlexBox';
import { shouldForwardProp } from 'src/components/Particles/Particles';
const ActivityBox = styled(FlexColumn)(() => ({
  // position: 'relative',
  width: '7rem',
  height: '7rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  alignSelf: 'center'
}));
type ActivityProps = Omit<React.ComponentProps<typeof CircularProgress>, 'color'> & {
  background?: boolean;
};
const StyledProgress = styled(CircularProgress, {
  ...shouldForwardProp(['color'])
})<ActivityProps>(({
  theme,
  color
}) => ({
  position: 'absolute',
  color: color || theme.colors.surface.brand,
  borderRadius: theme.sizes.radius.full,
  variants: [{
    props: ({
      variant,
      value
    }) => variant === 'determinate' && value === 100,
    style: {
      opacity: 0.06
    }
  }]
}));
const Activity: React.FC<ActivityProps> = t0 => {
  const $ = _c(10);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      background: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const background = t1 === undefined ? true : t1;
  let t2;
  if ($[3] !== background) {
    t2 = background && <StyledProgress variant="determinate" value={100} size="6.875rem" thickness={4} />;
    $[3] = background;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props) {
    t3 = <StyledProgress thickness={4} size="6.875rem" {...props} />;
    $[5] = props;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <ActivityBox>{t2}{t3}</ActivityBox>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default Activity;
export type { ActivityProps };